import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const FUNDAMENTALPROCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FundamentalProcess.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FundamentalProcess.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const FUNDAMENTALPROCESS_CONFIG = {
  entityName: 'FundamentalProcess',
  localizationKey: 'General::Entity.FundamentalProcess',
  fields: FUNDAMENTALPROCESS_FIELDS,
  permission: 'ControllingProcess.FundamentalProcesses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Processes + MENU_NAME_SUFFIX,
};
